import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { Location } from '@angular/common';
import { environment } from '../../environments/environment';
import { ExpenseClaimsDocumentInfo, ExpenseClaimsInfo, ExpenseClaimsItemInfo } from '../model/ExpenseClaims.model';
import { FormControl } from '@angular/forms';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';
import { ProjectInfo } from '../model/project.model';

@Component({
  selector: 'app-expense-claims-item',
  templateUrl: './expense-claims-item.component.html',
  styleUrls: ['./expense-claims-item.component.css']
})
export class ExpenseClaimsItemComponent implements OnInit {

  baseurl: string;
  _ForK2: string;
  _EmpCode: string;


  // Page Functionality
  mode: string = 'View';
  access: string;
  Id: number;


  // Primary data
  modelViewOnPromise: Promise<ExpenseClaimsInfo>
  modelOnPromise: Promise<ExpenseClaimsItemInfo[]>
  modelList: ExpenseClaimsItemInfo[] = [];
  modelFilteredList: ExpenseClaimsItemInfo[] = [];

  modelDocumentOnPromise: Promise<ExpenseClaimsDocumentInfo[]>
  modelDocumentList: ExpenseClaimsDocumentInfo[] = [];

  // Modal variables
  txtSchProjectCodeOrName: string;
  totalProject: number = 0;
  modelAddList: ExpenseClaimsItemInfo[] = [];

  // Binded variables
  txtFrmCreateDate: string;
  txtFrmStatus: string;
  txtFrmRequestBy: string;
  txtFrmReceiptDate: string;
  txtFrmExpenseType: string;
  txtFrmTotalAmount: string;
  txtFrmRemark: string;

  txtFrmDocno: string;

  // File Upload
  isUploadSubmitted: boolean = false;
  FilesToUpload: File[];
  PathFile: string = '';
  IsClearList: boolean = false;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService, private activatedRoute: ActivatedRoute, private location: Location) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.mode = this.activatedRoute.snapshot.params.Action;
    this.Id = Number(this.activatedRoute.snapshot.params.Id);
    this.access = this.activatedRoute.snapshot.params.Access;

    if (this.mode == 'Create') {
      this.txtFrmRequestBy = localStorage.getItem("EmpName_TH");
      this.txtFrmStatus = 'Draft'
    } else if ((this.mode == 'Edit')) {
      this.txtFrmRequestBy = localStorage.getItem("EmpName_TH");
    }
    

    //GlobalService.CheckPagingAccessRights();
  }

  //============================ ngOnInit [Start] ===============================================
  ngOnInit(): void {

    console.log(this._EmpCode)

    this.LoadClaimable();
  }
  //============================ ngOnInit [End] ===============================================

  //============================ onEvent [Start] ===============================================
  btnClick_openClaimable() {
    this.modelAddList = this.modelList;
    this.totalProject = this.modelAddList.reduce((sum, current) => sum + (current.isChecked ? 1 : 0), 0);
    $('#ModalAddClaimable').modal('show');
  }

  btnClick_closeClaimable() {
    this.modelAddList = this.modelList;

    $('#ModalAddClaimable').modal('hide');
  }

  btnClick_saveClaimable() {
    this.modelList = this.modelAddList;
    this.modelFilteredList = this.modelList.filter(x => { return x.isChecked });

    console.log('RESULT')
    console.log(this.modelFilteredList)

    $('#ModalAddClaimable').modal('hide');

    this.refreshDisplay();
  }

  btnClick_uncheckAllClaimable() {
    this.modelList.forEach((itemcurrent) => {
      if (itemcurrent.ExpenseStatusCode != 'APPROVED' && itemcurrent.ExpenseStatusCode != 'PAPPROVE') {
        itemcurrent.isChecked = false;
      }
    });
    this.modelAddList = this.modelList;
    this.modelFilteredList = [];

    this.refreshDisplay();
  }

  btnClick_saveAsDraft() {
    if (this.Validate()) {
      this.saveDraft();
    }
  }

  btnClick_saveAndSubmit() {
    if (this.Validate()) {
      this.saveSubmit();
    }
  }

  btnClick_goBack() {
    this.location.back();
  }

  btnClick_approve() {
    this.approve();
  }

  btnClick_revise() {
    this.revise();
  }


  refreshDisplay() {
    this.txtFrmTotalAmount = this.modelFilteredList.reduce((sum, current) => sum + current.Amount, 0).toString();
    this.txtFrmExpenseType = Array.from(new Set(this.modelFilteredList.map((item: any) => item.ExpenseTypeCodeDisplay))).join(',');
  }

  OnSearchProjectKeyUp() {
    if (this.txtSchProjectCodeOrName != "" && this.txtSchProjectCodeOrName != null) {

      this.modelAddList = this.modelList.filter(x => { return x.ProjectCode.toLowerCase().indexOf(this.txtSchProjectCodeOrName.toLowerCase()) > -1 || x.ProjectName.toLowerCase().indexOf(this.txtSchProjectCodeOrName.toLowerCase()) > -1 })
    } else {
      this.modelAddList = this.modelList;
    }
  }

  OnAmountKeyup(e, m): number {
    e.target.valueAsNumber = isNaN(parseFloat(e.target.value)) ? 0.00 : (parseFloat(e.target.value) > m) ? m.toFixed(2) : parseFloat(e.target.value).toFixed(2);
    return e.target.valueAsNumber;
  }

  async OnDeleteExpenseClaimsDocumentClick(elem) {

    if (confirm('Confirm delete?')) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let dataInfo = $(elem).parent().data();

        var objectjson = {};
        objectjson['ExpenseClaimsID'] = dataInfo.documentid;

        let strjson = JSON.stringify(objectjson);
        this.httpClient
          .post<boolean>(this.baseurl + "ExpenseClaims/DeleteExpenseClaimsDocument",
            strjson, httpOptions)
          .subscribe({
            next: data => {
              this.LoadClaimsDocument();
            },
            error: error => {
              console.error('There was an error!', error);
            }
          })
      }
    }
  }

  //Upload file
  DragFilesFinished(returnObj) {
    
    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.FilesToUpload = returnObj.Files;
      this.PathFile = returnObj.PathFile;
    }
  }

  btnClick_submitUpload() {
    if (this.txtFrmDocno != "" && this.txtFrmDocno != null) {
      this.isUploadSubmitted = true;

      this.UploadFilesToServer(this.FilesToUpload);
    }



  }

  btnClick_openUploadDialog() {
    //$('#ddlFileType').val('create');
    //this.FilesToUpload = [];
    this.isUploadSubmitted = false;
    this.IsClearList = false;
  }

  //============================ onEvent [End] ===============================================

  //============================ Data Loading [Start] =========================================

  LoadClaimable() {
    if (this.mode == 'Create') {
      this.getClaimable()
        .then(
          data => {
            this.modelList = data;
            this.modelAddList = this.modelList;

            console.log('Claimable')
            console.log(this.modelList)
            //this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          }
        )
    } else if (this.mode == 'Edit' || this.mode == 'View') {
      this.getClaimableEdit()
        .then(
          data => {
            this.modelList = data.Claimable;
            this.modelAddList = this.modelList;
            this.modelFilteredList = this.modelList.filter(x => { return x.isChecked });

            this.txtFrmCreateDate = data.CreateDate != null ? new Date(data.CreateDate).toLocaleDateString('en-CA') : null
            this.txtFrmStatus = data.ExpenseStatusCodeDisplay;
            this.txtFrmReceiptDate = data.ReceiptDate != null ? new Date(data.ReceiptDate).toLocaleDateString('en-CA') : null
            this.txtFrmExpenseType = data.ExpenseTypeCodeDisplay;
            this.txtFrmTotalAmount = data.TotalAmount.toFixed(2).toString();
            this.txtFrmRequestBy = data.RequestByDisplay;
            this.txtFrmRemark = data.Remark;
            this.txtFrmDocno = data.DocumentRequestNo;

            this.refreshDisplay();

            this.LoadClaimsDocument();

            console.log(data)

            console.log('ClaimableEdit')
            console.log(this.modelList)
            //this.YearList = [...new Set(data.map(event => new Date(event.TimeSheetDate).getFullYear().toString()))];
          }
        )
    }
    
  }

  async getClaimable(): Promise<ExpenseClaimsItemInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['RequestBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.modelOnPromise = this.httpClient
        .post<ExpenseClaimsItemInfo[]>(this.baseurl + "ExpenseClaims/GetExpenseClaimable",
          strjson, httpOptions)
        .toPromise()

      return this.modelOnPromise;
    }
  }

  async getClaimableEdit(): Promise<ExpenseClaimsInfo> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['Id'] = this.Id;

      if (this.access == 'Approve') objectjson['ApproveBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.modelViewOnPromise = this.httpClient
        .post<ExpenseClaimsInfo>(this.baseurl + "ExpenseClaims/GetExpenseClaimsViewForEdit",
          strjson, httpOptions)
        .toPromise()

      return this.modelViewOnPromise;
    }
  }

  async saveDraft() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      
      if (this.mode == 'Edit') objectjson['Id'] = this.Id;
      objectjson['ExpenseStatusCode'] = 'DRAFT';
      objectjson['RequestBy'] = this._EmpCode;
      objectjson['ReceiptDate'] = this.txtFrmReceiptDate;
      objectjson['Remark'] = this.txtFrmRemark;
      objectjson['Claimable'] = this.modelAddList;

      let strjson = JSON.stringify(objectjson);

      let isSubmitted = new SimpleTextInfo();
      this.httpClient
        .post<SimpleTextInfo>(this.baseurl + "ExpenseClaims/SaveExpenseClaimable",
          strjson, httpOptions)
        .subscribe(result => isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {

            this.txtFrmDocno = isSubmitted.Value;

            if (this.FilesToUpload != null) {
              console.log("Upload begun:" + this.txtFrmDocno)
              this.btnClick_submitUpload();
            }

            console.log("Submit = " + isSubmitted.Value);
            $('#ModalSaveSuccess').modal();
          });
    }
  }

  async saveSubmit() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      if (this.mode == 'Edit') objectjson['Id'] = this.Id;
      objectjson['ExpenseStatusCode'] = 'PAPPROVE';
      objectjson['RequestBy'] = this._EmpCode;
      objectjson['ReceiptDate'] = this.txtFrmReceiptDate;
      objectjson['Remark'] = this.txtFrmRemark;
      objectjson['Claimable'] = this.modelAddList;

      let strjson = JSON.stringify(objectjson);

      let isSubmitted = new SimpleTextInfo();
      this.httpClient
        .post<SimpleTextInfo>(this.baseurl + "ExpenseClaims/SaveExpenseClaimable",
          strjson, httpOptions)
        .subscribe(result => isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {

            this.txtFrmDocno = isSubmitted.Value;

            if (this.FilesToUpload != null) {
              console.log("Upload begun:" + this.txtFrmDocno)
              this.btnClick_submitUpload();
            }

            console.log("Submit = " + isSubmitted.Value);
            $('#ModalSaveSuccess').modal();
          });
    }
  }

  async approve() {

    let allowapprove = true;

    this.modelFilteredList.forEach(function (obj) {
      if (obj.Amount > obj.Available) allowapprove = false;
    });

    if (!allowapprove) {
      alert('Requested amount exceeded available budget, cannot approve.');
      return;
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['Id'] = this.Id;
      objectjson['Approver'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      let isSubmitted;
      this.httpClient
        .post<Boolean>(this.baseurl + "ExpenseClaims/ApproveExpenseClaims",
          strjson, httpOptions)
        .subscribe(result => isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {
            console.log("Submit = " + isSubmitted);
            $('#ModalApproveSuccess').modal();
          });
    }
  }

  async revise() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['Id'] = this.Id;
      objectjson['Approver'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      let isSubmitted;
      this.httpClient
        .post<Boolean>(this.baseurl + "ExpenseClaims/ReviseExpenseClaims",
          strjson, httpOptions)
        .subscribe(result => isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {
            console.log("Submit = " + isSubmitted);
            $('#ModalReviseSuccess').modal();
          });
    }
  }

  UploadFilesToServer(files) {

    if (files.length === 0) {
      alert("Please browse file at least one.")
      return;
    }
    let filesToUpload: File[] = files;

    Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.PathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
              // check upload count

            }

          } else if (event.type === HttpEventType.Response) {

            this.IsClearList = true;
            this.UploadFinished(event.body);

          }
        });


    });

  }

  UploadFinished(traget) {
    //$('#modalFileController').modal('hide');

    this.InsertProjectDocument(traget.list[0].fileName, traget.list[0].dbPath);
  }

  async InsertProjectDocument(filename, pathfile) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['DocumentRequestNo'] = this.txtFrmDocno;
      objectjson['PathFile'] = pathfile;
      objectjson['FileName'] = filename;
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");



      let strjson = JSON.stringify(objectjson);

      let isSubmitted = this.httpClient.post<ExpenseClaimsDocumentInfo[]>(this.baseurl + "ExpenseClaims/InsertExpenseClaimsDocument", strjson, httpOptions)

        .subscribe(result => isSubmitted = result, failCb => {

          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + isSubmitted)

            this.LoadClaimsDocument();
          }
        )
    }
  }

  LoadClaimsDocument() {
    this.getClaimsDocument()
      .then(
        data => {
          this.modelDocumentList = data;
        }
      )

  }

  async getClaimsDocument(): Promise<ExpenseClaimsDocumentInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['DocumentRequestNo'] = this.txtFrmDocno;

      let strjson = JSON.stringify(objectjson);

      this.modelDocumentOnPromise = this.httpClient
        .post<ExpenseClaimsDocumentInfo[]>(this.baseurl + "ExpenseClaims/GetExpenseClaimsDocument",
          strjson, httpOptions)
        .toPromise()

      return this.modelDocumentOnPromise;
    }
  }

  //============================ Data Loading [End] =========================================

  //============================ Misc Functions [Start] =========================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput;

  }

  chkallclick(target) {
    //var check = $(target.currentTarget).is(":checked");
    //$('[name="checkboxProjectDocument"]').prop('checked', check);
    //this.totalProject = $('[name="checkboxProjectDocument"]:checked').length;

    let totalchanged = 0;
    this.modelAddList.forEach((itemcurrent) => {
      if (itemcurrent.isChecked != true) {
        itemcurrent.isChecked = true;
        totalchanged++;
      }
      
    });

    if (totalchanged == 0) {
      this.modelAddList.forEach((itemcurrent) => {
        if (itemcurrent.ExpenseStatusCode != 'APPROVED' && itemcurrent.ExpenseStatusCode != 'PAPPROVE') {
          itemcurrent.isChecked = false;
        }
          
      });
    }

    this.totalProject = this.modelAddList.reduce((sum, current) => sum + (current.isChecked ? 1 : 0), 0);
    
  }

  OnCheckboxChecked() {
    this.totalProject = $('[name="checkboxProjectDocument"]:checked').length;
    $('#headCheck').prop('checked', this.totalProject == $('[name="checkboxProjectDocument"]').length);

  }

  Validate() {
    if (this.txtFrmReceiptDate == null || this.txtFrmReceiptDate == "") alert('Please input Receipt Date.')
    else if (this.txtFrmRemark == null || this.txtFrmRemark == "") alert('Please input Remark.')
    else if (this.modelAddList.length == 0) alert('Please add project before create receipt.')
    else if (this.txtFrmTotalAmount == null || this.txtFrmTotalAmount == "" || parseFloat(this.txtFrmTotalAmount) <= 0) alert('Please make sure amount more than 0.')
    else return true;
    return false;
  }
  //============================ Misc Function [End] =========================================

}
